var React = require('react');

function ArrowDownSmall (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"x":"12","y":"7.5","width":"7","height":"1","transform":"rotate(135 12 7.5)","fill":"white","key":0}),React.createElement("rect",{"x":"2.80859","y":"6.79297","width":"7","height":"1","transform":"rotate(45 2.80859 6.79297)","fill":"white","key":1}),React.createElement("rect",{"x":"7.53125","y":"3.50781","width":"8.00005","height":"1","transform":"rotate(90 7.53125 3.50781)","fill":"white","key":2})]);
}

ArrowDownSmall.defaultProps = {"width":"14","height":"15","viewBox":"0 0 14 15","fill":"none"};

module.exports = ArrowDownSmall;

ArrowDownSmall.default = ArrowDownSmall;
